import { render, staticRenderFns } from "./PassWordLogin.vue?vue&type=template&id=898cf002&scoped=true&"
import script from "./PassWordLogin.vue?vue&type=script&lang=js&"
export * from "./PassWordLogin.vue?vue&type=script&lang=js&"
import style0 from "./PassWordLogin.vue?vue&type=style&index=0&id=898cf002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898cf002",
  null
  
)

export default component.exports